import {Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-scriptDebug',
  templateUrl: './scriptDebug.component.html'
})
export class ScriptDebugComponent implements OnInit, OnChanges {

  @Input()
  chatApp: any;
  @Input()
  apiPath: string;
  @Input()
  descriptorVars: any;
  @Input()
  embedded: boolean = false;

  script: string;
  testResponse: any;
  testRunning: boolean = false;
  vars: any[] = [];
  newVar:any;
  msg: string;


  constructor(protected authService: AuthService,
              private alertService:AlertService,
              protected env: EnvService,
              protected http: HttpClient) {
  }

  ngOnInit() {
    this.resetNewVar();
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  testScript() {
    this.testResponse = null;
    let test = {
      chatApp: this.chatApp,
      script: "(){" + this.script +"}",
      vars: {"msg": this.msg},
    }

    for (let v of this.vars) {
      test.vars[v.name] = v.value;
    }

    this.testRunning = true;
    this.http.post(`${this.env.e.url}${this.apiPath}`, test)
      .subscribe(
        (data) => {
          this.testResponse = data;
          this.testRunning = false;
          var respVars = [];
          for (let testResponseKey in this.testResponse.vars) {
            respVars.push({name: testResponseKey, value: this.testResponse.vars[testResponseKey]});
          }
          this.testResponse.vars = respVars;
        },
        (error) => {
          this.testRunning = false;
        });
  }

  resetNewVar() {
    this.newVar = {
      "name": "",
      "value": ""
    };
  }

  addVar() {
    this.vars.push({
      "name": this.newVar.name,
      "value": this.newVar.value
    });
    this.resetNewVar();
  }

  removeVar(i) {
    this.newVar.splice(i, 1);
  }
}
